import { Injectable } from '@angular/core';
import { ErrorModalComponent } from '@app/error-modal/error-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActiveToast, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  bsModalRef?: BsModalRef;
  // Variabile per monitorare il cambio lingua
  public languageChanged: boolean = false;

  constructor(
    public toasterService: ToastrService,
    private bsModalService: BsModalService
  ) {}

  //in base al tipo di errore apro il toast o la modale
  showError(
    error_message: string,
    error_code: string,
    correlationIdMessage: string
  ) {
    debugger;
    //se l'errore è di autorizzazione mostro la modale altrimenti mostro il toast se MT_NTA_003 gestione a se(ignoro l'errore per evitare problemi in virtual-token)
    if (
      error_code.includes('MT_AUT') ||
      error_code.includes('MS_GEN') ||
      error_code.includes('MT_GEN') ||
      error_code === 'MS_NTF_002' ||
      (error_code.includes('MT_NTA') && error_code != 'MT_NTA_003')
    ) {
      this.openErrorModal(error_message, error_code);
    } else {
      //inibisco la visibiltà del toast d'errore per evitare che appaia visibile l'errore di autenticazione nel toast prima del refresh della session
      if (!localStorage.getItem('error_toast')) {
        this.openToast(error_message, error_code, correlationIdMessage);
      } else {
        if (error_code != 'MS_AUT_002') {
          this.openToast(error_message, error_code, correlationIdMessage);
        }
      }
    }
  }
  //apro la modale d'errore
  openErrorModal(error_message: string, error_code?: string) {
    //salvo l'error_message nello storage
    sessionStorage.setItem('errorMessage', error_message);
    //salvo l'error_code per permettere alla modale di mostrare un contenuto dedicato (es. MS_NTF_002)
    if (error_code) {
      sessionStorage.setItem('errorCode', error_code);
    }

    this.bsModalService.show(ErrorModalComponent, {
      id: 'error',
      class: 'modal-dialog-centered',
      ignoreBackdropClick: true,
      keyboard: false,
    });
  }

  //apro il toast d'errore
  openToast(
    error_message: string,
    error_code: string,
    correlationIdMessage: string
  ) {
    debugger;
    //salvo l'error_code nella session
    sessionStorage.setItem('errorCode', error_code);
    //salvo l'error_message nello storage
    sessionStorage.setItem('errorMessage', error_message);
    //ignoro la validazione del numero di telefono
    if (error_code === 'MT_VAL_006') {
      console.log('invalid number');
    } else {
      //aggiungo il punto alla fine per i messaggi dei codici diversi da MIG perchè non lo hanno
      if (error_code.includes('MT_MIG')) {
        const toast = this.toasterService.error(
          '<b>' +
            error_message +
            '</b>' +
            '                               ' +
            '<span class="break-line">' +
            correlationIdMessage,
          'error_code',
          {
            tapToDismiss: false,
            disableTimeOut: true,
            closeButton: true,
            positionClass: 'toast-top-center',
          }
        );

        this.closeToastActions(toast);
      } else {
        const toast = this.toasterService.error(
          '<b>' +
            error_message +
            '</b>' +
            '.                               ' +
            '<span class="break-line">' +
            correlationIdMessage,
          'error_code',
          {
            tapToDismiss: false,
            disableTimeOut: true,
            closeButton: true,
            positionClass: 'toast-top-center',
          }
        );

        this.closeToastActions(toast);
      }
    }
  }

  closeToastActions(toast: ActiveToast<any>) {
    // Qui puoi inserire le azione che vuoi eseguire al momento della chiusura
    toast.onHidden.subscribe(() => {
      sessionStorage.removeItem('errorMessage');
      //se la variabile del cambio lingua è true non rimuovo l'errorCode perchè mi servirà per aprire il toast tradotto con la nuova lingua (visto che non reagsice alla tarduzione della lingua)
      if (!this.languageChanged) {
        sessionStorage.removeItem('errorCode');
      } else {
        this.languageChanged = false;
      }
    });
  }

  //ritorna lo stato della variabile del cambio lingua
  updateLanguageChanged(status: boolean) {
    this.languageChanged = status;
  }
}
